export default "__VITE_ASSET__Dbef2P_h__"